<template>
    <div class="content nodeExtraction">
        <p class="location">&nbsp;<span class="spans_2" @click="routerFun">价格抽取管理</span> / <span class="spans_1">价格抽取节点管理</span></p>
        <div class="searchs" ref="searchs">
            <div class="search">
                <el-form ref="form" :inline="true" :model="form" label-width="120px">
                    <el-form-item label="节点名称">
                        <el-input v-model="form.node_msg" clearable placeholder="请输入节点名称或节点编码"></el-input>
                    </el-form-item>
                    <el-form-item label="节点类型">
                        <el-select v-model="form.node_types" filterable clearable placeholder="请选择">
                            <el-option v-for="(item,index) in typesArr" :key="index" :label="item.node_type" :value="item.node_type">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="节点详细类型">
                        <el-select v-model="form.detail_types" filterable clearable placeholder="请选择" v-if="form.node_types">
                            <el-option v-for="(item,index) in detailArr" :key="index" v-if="form.node_types == item.node_type" :label="item.node_detail_type" :value="item.node_detail_type">
                            </el-option>
                        </el-select>
                        <el-select v-model="form.detail_types" filterable clearable placeholder="请选择" v-else>
                            <el-option v-for="(item,index) in detailArr" :key="index" :label="item.node_detail_type" :value="item.node_detail_type">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属区县">
                        <el-select v-model="form.addr" filterable clearable placeholder="请选择">
                            <el-option v-for="(item,index) in addrArr" :key="index" :label="item.district_name" :value="item.district_name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数据抽取类型">
                        <el-select v-model="form.extract_types" filterable clearable placeholder="请选择">
                            <el-option v-for="(item,index) in extractArr" :key="index" :label="item.text" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="search-btn" @click="searchFun" style="margin-left: 10px;">搜索</el-button>
                        <el-button @click="clearFun">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="table" v-loading="loading">
            <div class="title">
                <p class="tz-title">节点列表</p>
                <div>
                    <el-button v-if="editAllBtn == '批量修改'" type="primary" @click="addFun"> + 添加</el-button>
                    <el-button v-if="editAllBtn == '批量修改'" @click="downloadFun">导出</el-button>
                    <div class="submit" v-if="editAllBtn == '批量修改'">
                        批量导入
                        <form id="upload" enctype="multipart/form-data" method="post"> 
                            <input type="file" class="file" ref="file" @change="fileFun($event)">
                        </form> 
                    </div>
                    <el-button v-if="editAllBtn == '完成'" @click="cancelFun">取消</el-button>
                    <el-button @click="allEditFun">{{editAllBtn}}</el-button>
                </div>
            </div>
            <el-table :data="tableData" :header-cell-style="rowClass" :style="editAllBtn == '批量修改' ? {'display': 'block'} : {'display': 'none'}">
                <el-table-column prop="node_id" label="节点编码"></el-table-column>
                <el-table-column prop="node_name" label="节点名称"></el-table-column>
                <el-table-column prop="addr" label="地址"></el-table-column>
                <el-table-column prop="parent" label="父节点编码"></el-table-column>
                <el-table-column prop="group_name" label="集团名称"></el-table-column>
                <el-table-column prop="node_type" label="节点类型"></el-table-column>
                <el-table-column prop="node_detail_type" label="节点详细类型"></el-table-column>
                <el-table-column prop="district_name" label="所属区县"></el-table-column>
                <el-table-column prop="data_source" label="数据抽取类型"></el-table-column>
                <el-table-column prop="varieties_type" label="是否补充数据"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editFun(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="viewFun(scope.row)">查看商品</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-table :data="tableData" :header-cell-style="rowClass" :style="editAllBtn == '批量修改' ? {'display': 'none'} : {'display': 'block'}">
                <el-table-column prop="node_id" label="节点编码">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.node_id" clearable @input="inputFun(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="node_name" label="节点名称">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.node_name" clearable @input="inputFun(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="addr" label="地址">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.addr" clearable @input="inputFun(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="parent" label="父节点名称">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.parent" clearable @input="inputFun(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="group_name" label="集团名称">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.group_name" clearable @input="inputFun(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="node_type" label="节点类型">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.node_type" filterable clearable placeholder="请选择" @input="inputFun(scope.row)">
                            <el-option v-for="(item,index) in typesArr" :key="index" :label="item.node_type" :value="item.node_type">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="node_detail_type" label="节点详细类型">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.node_detail_type" filterable clearable placeholder="请选择" v-if="scope.row.node_type">
                            <el-option v-for="(item,index) in detailArr" :key="index" v-if="scope.row.node_type == item.node_type" :label="item.node_detail_type" :value="item.node_detail_type">
                            </el-option>
                        </el-select>
                        <el-select v-model="scope.row.node_detail_type" filterable clearable placeholder="请选择" v-else>
                            <el-option v-for="(item,index) in detailArr" :key="index" :label="item.node_detail_type" :value="item.node_detail_type">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="district_name" label="所属区县">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.district_name" @input="inputFun(scope.row)" filterable clearable placeholder="请选择">
                            <el-option v-for="(item,index) in addrArr" :key="index" :label="item.district_name" :value="item.district_name">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="types" label="数据抽取类型">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.types" @input="inputFun(scope.row)" filterable clearable placeholder="请选择">
                            <el-option v-for="(item,index) in extractArr" :key="index" :label="item.text" :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="varieties_type" label="是否补充数据">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.varieties_type" clearable @input="inputFun(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editFun(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="viewFun(scope.row)">查看商品</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="total" background @current-change="handleCurrentChange" :current-page.sync="page" :page-size="cols"
                layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 30, 40]"
                @size-change="handleSizeChange"></el-pagination>
        </div>
    </div>
</template>

<script>
function getNowFormatDate() {//获取当前时间
    var date = new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
    var strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
    var currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
            + " "  + date.getHours()  + seperator2  + date.getMinutes()
            + seperator2 + date.getSeconds();
    return currentdate
}
import {QueryNodePriceExtract, NodePriceType, DownloadPriceNodeExtract, BatchUpdatePriceNode} from '../../js/compare/compare.js'
import {importPriceNodeExtract} from '../../js/address/url.js'
import axios from 'axios';
export default {
    name:"nodeExtraction",
    data() {
        return {
            page: 1,
            cols: 10,
            total: 0,
            tableData: [],
            form: {
                node_msg: '',
                node_types: '',
                detail_types: '',
                addr: '',
                extract_types: '',
            },
            typesArr: [],
            detailArr: [],
            addrArr: [],
            extractArr: [],
            loading: true,
            editAllBtn: '批量修改',
            editArr: [],
            file: '',
        }
    },
    mounted() {
        let routeMsg1 = '';
        if(localStorage.getItem('routeMsg1')){
            routeMsg1 = JSON.parse(localStorage.getItem('routeMsg1'))
        }
        if(localStorage.getItem('district_name')){
            this.form.addr = JSON.parse(localStorage.getItem('district_name'))
        }
        if(localStorage.getItem('searchMsg2')){
            this.form = JSON.parse(localStorage.getItem('searchMsg2'))
            localStorage.removeItem('searchMsg2')
        }
        this.getNodePriceType()
        this.getDataFun()
    },
    methods: {
        routerFun(){
            this.$router.push({name: 'PriceExtraction'})
        },
        getNodePriceType(){
            NodePriceType('')
                .then(res => {
                    this.typesArr = res.data.node_type
                    this.detailArr = res.data.node_detail_type
                    this.addrArr = res.data.district_name
                    this.extractArr = res.data.data_source
                })
                .catch(res => {
                    console.log(res)
                })
        },
        inputFun(ele){
            if(this.editArr.length == 0){
                this.editArr.push(ele)
            }else{
                this.editArr.forEach((val,index) => {
                    if(val.id == ele.id){
                        this.editArr.splice(index,1)
                    }
                })
                this.editArr.push(ele)
            }
        },
        addFun(){
            localStorage.setItem('searchMsg2', JSON.stringify(this.form))
            this.$router.push({name: 'NewNodeExtraction'})
        },
        editFun(ele){
            localStorage.setItem('searchMsg2', JSON.stringify(this.form))
            localStorage.setItem('routeMsg2', JSON.stringify(ele))
            this.$router.push({name: 'EditNodeExtraction', params: ele})
        },
        viewFun(ele){
            localStorage.setItem('searchMsg2', JSON.stringify(this.form))
            localStorage.setItem('routeMsg2', JSON.stringify(ele))
            this.$router.push({name: 'ReportGood', params: ele})
        },
        allEditFun(){
            if(this.editAllBtn == '批量修改'){
                this.editAllBtn = '完成'
                let arr = [], num = '';
            }else if(this.editAllBtn == '完成'){
                let arr = [], itemObj = {};
                if(this.editArr.length > 0){
                    this.editArr.forEach((val,index) => {
                        itemObj = {
                            id: val.id,
                            node_id: val.node_id,
                            node_name: val.node_name,
                            addr: val.addr,
                            parent: val.parent,
                            node_type: val.node_type,
                            node_detail_type: val.node_detail_type,
                            group_name: val.group_name,
                            district_name: val.district_name,
                            x_coordinate: val.x_coordinate,
                            y_coordinate: val.y_coordinate,
                            data_source: val.data_source,
                            varieties_type: val.varieties_type
                        }
                        arr.push(itemObj)
                    })
                    let obj = "{" + '"data"' + ":" + JSON.stringify(arr) + "}"
                    BatchUpdatePriceNode(obj)
                        .then(res => {
                            if (res.result == true) {
                                this.$message.success('修改成功');
                                this.editAllBtn = '批量修改'
                                this.editArr = []
                                this.getDataFun()
                            }else{
                                this.$message.error('修改失败');
                            }
                        })
                        .catch(res => {
                            this.loading = false
                            console.log(res)
                        })
                }else{
                    this.editAllBtn = '批量修改'
                    this.editArr = []
                    this.getDataFun()
                }
            }
        },
        cancelFun(){
            this.editAllBtn = '批量修改'
            this.editArr = []
            this.getDataFun()
        },
        downloadFun(){
            let params = {
                node_name: this.form.node_msg,
                node_type: this.form.node_types,
                node_detail_type: this.form.detail_types,
                district_name: this.form.addr,
                data_source: this.form.extract_types,
            }
            DownloadPriceNodeExtract( params, {})
                .then((res) => {
                    let time = getNowFormatDate()
                    let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", `价格抽取节点管理` + time);
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); 
                    window.URL.revokeObjectURL(url); 
                })
                .catch(function (res) {});
        },
        // 上传
        fileFun(event){
            let param = this.$refs.file.files[0];
            this.file = event.target.files[0];
            let formData = new FormData();
            formData.append('price_node', this.file);  
            let config = {
                headers:{'Content-Type':'multipart/form-data'}
            };
            const ajaxPost = function (url, params,config) {
                return new Promise((resolve, reject) => {
                    axios
                    .post(url, params,{config})
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch(() => {
                        reject('error')
                    })
                })
            }  
            let url = importPriceNodeExtract
            ajaxPost(url,formData,config)
                .then(res => {
                    if (res.result == true) {
                        if(res.message){
                            this.$message.success(res.message);
                        }else{
                            this.$message.success('导入成功');
                        }
                        this.getDataFun()
                    }else{
                        if(res.message){
                            this.$message.error(res.message);
                        }else{
                            this.$message.error('导入失败');
                        }
                    }
                    this.file = ''
                })
                .catch(res => {
                    console.log(res)
                })
        },
        getDataFun(){
            this.loading = true
            let obj = {
                page: this.page,
                cols: this.cols,
                node_name: this.form.node_msg,
                node_type: this.form.node_types,
                node_detail_type: this.form.detail_types,
                district_name: this.form.addr,
                data_source: this.form.extract_types,
            }
            QueryNodePriceExtract(obj)
                .then(res => {
                    this.loading = false
                    this.total = res.data.condition.total
                    let arr = [], num = '';
                    res.data.dataList.forEach(val =>{
                        this.extractArr.forEach(val2 => {
                            if(val2.text == val.data_source){
                                val.types = val2.id
                            }
                        })
                    })
                    this.tableData = res.data.dataList 
                })
                .catch(res => {
                    this.loading = false
                    console.log(res)
                })
        },
        handleSizeChange(val){
            this.cols = val
            this.getDataFun()
        },
        handleCurrentChange(val) {
            this.page = val
            this.getDataFun()
        },
        searchFun(){
            this.page = 1
            this.getDataFun()
        },
        clearFun(){
            this.form = {
                node_msg: '',
                node_types: '',
                detail_types: '',
                addr: '',
                extract_types: '',
            }
            this.page = 1
            this.getDataFun()
        },
        rowClass({ row, rowIndex}) {
            return {
                background: '#f2f2f2',
                color: '#333'
            }
        },
    },
}
</script>

<style scoped lang='less'>
    .content{
        width: 100%;
        height: 100%;
        .searchs{
            padding: 10px 0;
            background: #fff;
            .search{
                .file-btn{
                    color: #777;
                    background: #fff;
                    border-color: #eaeaea;
                }
                .search-btn{
                    color: #409EFF;
                    background: #fff;
                }
                .clear-content{
                    margin-left: 10px;
                    cursor: pointer;
                    color: #999999;
                    font-size: 14px;
                }
                .el-form{
                    min-width: 950px;
                }
                .el-input,.el-date-picker,.el-select,.el-cascader{
                    width: 200px;
                }
                .unfold{
                    text-align: center;
                    font-size: 14px;
                    color: #409EFF;
                    cursor: pointer;
                }
                .el-form-item{
                    margin-bottom: 0;
                }
            }
        }
        .table{
            margin-top: 10px;
            padding: 10px;
            background: #fff;
            .link_btns{
                color: #409EFF;
                cursor: pointer;
            }
            .title{
                display: flex;
                margin-bottom: 10px;
                .tz-title{
                    flex: 1;
                    padding-left: 4px;
                    height: 20px;
                    font-size: 14px;
                    line-height: 20px;
                    box-sizing: border-box;
                    border-left: 2px solid #409EFF;
                }
                div{
                    display: flex;
                    width: 300px;
                    justify-content: flex-end;
                }
                .submit{
                    position: relative;
                    top: 0;
                    display: inline-block;
                    margin: 0 10px;
                    width: 90px;
                    height: 30px;
                    line-height: 30px;
                    color: #409EFF;
                    background: #fff;
                    text-align: center;
                    overflow: hidden;
                    border-radius: 5px;
                    font-size: 14px;
                    box-sizing: border-box;
                    border: 1px solid #409EFF;
                    .file{
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 90px;
                        height: 30px;
                        opacity: 0;
                        background: rgba(0,0,0,0);
                    }
                }
            }
            .zpg{
                display: flex;
                align-items: center;
                .sele-cursor{
                    height: 20px;
                    cursor: pointer;
                }
            }
            .task_name{
                p{
                    width: 100%;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space:nowrap;
                }
            }
        }
        .el-pagination{
            margin: 20px 0;
            text-align: center;
        }
    }
</style>
<style lang="less">
    .nodeExtraction{
        .el-input__icon{
            line-height: 30px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/compare/nodeExtraction.vue